import { types } from '../types/types';

const initialState = {
    admins: [], // usuarios administrador
    activeAdmin: { // edición de admin
        _id: '',
        email: '',
        username: '',
        role: '',
        privileges: {
            products: false,
            product_data: false,
            reviews: false,
            coupons: false,
            promotions: false,
            doctors: false,
            orders: false,
            shipping: false,
            banners: false,
            blog: false,
            clients: false,
            admins: false,
            contact: false
        }
    }
};

export const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.adminUsersLoaded:
            return {
                ...state,
                admins: [...action.payload]
            };
        case types.adminSelected:
            return {
                ...state,
                activeAdmin: action.payload
            };
        case types.adminRegistered:
            return {
                ...state,
                admins: [
                    ...state.admins,
                    action.payload
                ]
            };
        case types.adminUpdated:
            return {
                ...state,
                admins: state.admins.map(
                    e => (e._id === action.payload._id) ? action.payload : e
                ),
            };
        case types.adminDeleted:
            return {
                ...state,
                admins: state.admins.filter(
                    e => (e._id !== action.payload)
                ),
            };
        default:
            return state;
    };
};
